import { render, staticRenderFns } from "./DescriptionInput.vue?vue&type=template&id=86191e60&scoped=true&"
import script from "./DescriptionInput.vue?vue&type=script&lang=js&"
export * from "./DescriptionInput.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionInput.vue?vue&type=style&index=0&id=86191e60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86191e60",
  null
  
)

export default component.exports